<template>
  <div>
    <div class="section padding-top-bottom-small background-black over-hide footer">
      <div class="container">
        <div class="row">
          <div class="col-md-3 text-center text-md-left">
            <img src="img/logo.png" alt>
            <!-- <h5 style="color: white">Ogeyi's place</h5> -->
          </div>
          <div class="col-md-4 text-center text-md-left">
            <h6 class="color-white mb-3">Information</h6>
            <router-link active-class="currentpage" to="/gallery">Gallery</router-link>
            <router-link active-class="currentpage" to="/rooms">Rooms</router-link>
            <router-link active-class="currentpage" to="/about">About Us</router-link>
            <router-link active-class="currentpage" to="/resturant">Resturant</router-link>
            <router-link active-class="currentpage" to="/event">Meeting and Events</router-link>

            <!-- <a href="#/gallery">Gallery</a> -->
            <!-- <a href="services.html">Rooms</a> -->
            <!-- <a href="restaurant">Restaurant</a> -->
            <!-- <a href="events">Meeting and Events</a> -->
            <!-- <a href="testimonials.html">testimonials</a> -->
            <!-- <a href="gallery.html">Gallery &amp; images</a> -->
          </div>
          <div class="col-md-5 mt-4 mt-md-0 text-center text-md-left logos-footer">
            <h6 class="color-white mb-3">Location</h6>
            <p class="color-grey mt-4">
              45 Tombia Street, G.R.A Phase II,
              <br>Port Harcourt, Rivers State,
              <br>Nigeria.
              <br>N 04°40' E 07°0'
              <br>+234 02084 461770, +234 803 555 1160.
              <br><span id="siteseal"></span>

            </p>
            <!-- <img src="img/logos/1.png" alt>
            <img src="img/logos/2.png" alt>
            <img src="img/logos/3.png" alt>-->
          </div>
        </div>
      </div>
    </div>
    <div class="section py-4 background-dark over-hide footer-bottom">
      <div class="container">
        <div class="row">
          <div class="col-md-6 text-center text-md-left mb-2 mb-md-0">
            <p>2019 © Ogeyi's Place Hotel. All rights reserved.</p>
          </div>
          <div class="col-md-6 text-center text-md-right">
            <a href="#" class="social-footer-bottom">facebook</a>
            <a href="#" class="social-footer-bottom">twitter</a>
            <a href="#" class="social-footer-bottom">instagram</a>
          </div>
        </div>
      </div>
    </div>

    <div class="scroll-to-top"></div>
  </div>
</template>
<script>
export default {
  name: "footerComp",
  props: {
    msg: String
  }
};
</script>

